import { IconButton, styled } from "@mui/material";
import React from "react";
import MxIcons from "@rf-l1/MxIcons";
import { IconCheck, IconLoader2, IconReload } from "@tabler/icons-react";

export type UploadState = "uploading" | "uploaded" | "error";

interface MxUploadStatusIndicatorProps {
  state: UploadState;
  sx?: any;

  position?: "top-left" | "top-right" | "bottom-left" | "bottom-right";
}

const BaseIndicator = styled(IconButton)<{
  position?: "top-left" | "top-right" | "bottom-left" | "bottom-right";
}>(({ theme, position }) => ({
  position: "absolute",
  left: position === "top-left" || position === "bottom-left" ? "5px" : "unset",
  right: position === "top-right" || position === "bottom-right" ? "5px" : "unset",
  top: position === "top-left" || position === "top-right" ? "5px" : "unset",
  bottom:
    position === "bottom-left" || position === "bottom-right" ? "5px" : "unset",
  cursor: "pointer",
  margin: "5px",
  zIndex: 1,
  color: theme.palette.common.white,
  fontSize: 14,
  fontWeight: 400,
  transition: "all 0.3s",
  width: 25,
  height: 25,
  "&:hover": {
    backgroundColor: "unset"
  }
}));

const MxUploadStatusIndicator: React.FC<MxUploadStatusIndicatorProps> = ({
  state,
  sx,
  position
}) => {
  const bg =
    state === "uploading"
      ? "warning.main"
      : state === "uploaded"
      ? "success.main"
      : "error.main";

  return (
    <BaseIndicator
      sx={{ backgroundColor: bg, ...sx, "&:hover": { backgroundColor: bg } }}
      position={position ?? "bottom-right"}
    >
      {state === "uploading" && (
        <MxIcons size={16} className="loading">
          <IconLoader2 />
        </MxIcons>
      )}
      {state === "uploaded" && (
        <MxIcons size={16}>
          <IconCheck />
        </MxIcons>
      )}
      {state === "error" && (
        <MxIcons size={16}>
          <IconReload />
        </MxIcons>
      )}
    </BaseIndicator>
  );
};

export default MxUploadStatusIndicator;
